import React, { useState, SetStateAction, useEffect } from "react";
import { useOctokitRequest } from "../../hooks/useOctokitRequest";
// import { FieldProps } from "@rjsf/core";
import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import {
  Select,
  MenuItem,
  CircularProgress,
  FormControl,
} from "@material-ui/core";
import { useApi } from "@backstage/core-plugin-api";
import {
  scmAuthApiRef,
  scmIntegrationsApiRef,
} from "@backstage/integration-react";
import { Octokit } from "octokit";
import parseGitUrl from "git-url-parse";
import jsYaml from "js-yaml";

interface ListEntry {
  title: string;
  value: string;
}

export const ScaledObjectListField = ({
  onChange,
  rawErrors,
  formData,
  schema,
}: FieldExtensionComponentProps<string>): JSX.Element => {
  const items = schema.items as ListEntry[];
  const [env, setEnv] = useState<string>();
  const [worker, setWorker] = useState<string>("web");
  const [soEntries, setSoEntries] = useState<JSX.Element[]>([]);
  const scaledObjects = useOctokitRequest(
    `https://github.com/Kajabi/kubernetes/tree/main/kustomize/environments/${
      env || "development"
    }/kajabi-products/scaled-objects`
  );

  const authApi = useApi(scmAuthApiRef);
  const scmIntegrations = useApi(scmIntegrationsApiRef);

  useEffect(() => {
    (async () => {
      if (scaledObjects.value && scaledObjects.value.data) {
        const entries = Promise.all(
          scaledObjects.value.data.map(
            async (so: { name: string; html_url: string }) => {
              const n = so.name.split("-patch.yaml");
              const { owner, name, ref, filepath } = parseGitUrl(so.html_url);
              const path = filepath.replace(/^\//, "");
              const baseUrl = scmIntegrations.github.byUrl(so.html_url)?.config
                .apiBaseUrl;
              const { token } = await authApi.getCredentials({
                url: so.html_url,
              });
              const octokit = new Octokit({ auth: token, baseUrl });
              const data = await octokit.request(
                `GET /repos/${owner}/${name}/contents/${path}?ref=${ref}`,
                {
                  headers: { Accept: "application/vnd.github.v3.raw" },
                }
              );
              const yaml: any = await jsYaml.load(data.data);
              return (
                <MenuItem key={n[0]} value={n[0]}>
                  {n[0]} (Min: {yaml.spec.minReplicaCount} | Max:{" "}
                  {yaml.spec.maxReplicaCount})
                </MenuItem>
              );
            }
          )
        );

        setSoEntries(await entries);
      }
    })();
  }, [scaledObjects, authApi, scmIntegrations.github]);

  const envs = items.map((item: ListEntry) => {
    return (
      <MenuItem key={item.value} value={item.value}>
        {item.title}
      </MenuItem>
    );
  });

  if (!env) {
    return (
      <FormControl error={rawErrors?.length > 0 && !formData}>
        <Select
          value={env}
          label={schema.title}
          onChange={(event) => {
            const val = event.target.value;
            setEnv(val as SetStateAction<string | undefined>);
          }}
        >
          {envs}
        </Select>
      </FormControl>
    );
  }

  if (scaledObjects.loading || soEntries.length === 0) {
    return <CircularProgress />;
  }

  if (!scaledObjects.loading && !scaledObjects.value.data) {
    return <p>Something went wrong</p>;
  }

  return (
    <>
      <FormControl error={rawErrors?.length > 0 && !formData}>
        <Select
          value={env}
          label={schema.title}
          onChange={(event) => {
            const val = event.target.value;
            setEnv(val as SetStateAction<string | undefined>);
            onChange(val as string);
          }}
        >
          {envs}
        </Select>
      </FormControl>
      <FormControl error={rawErrors?.length > 0 && !formData}>
        <Select
          value={worker}
          label={schema.title}
          onChange={(event) => {
            const val = event.target.value;
            setWorker(val as SetStateAction<string>);
            onChange(JSON.stringify({ env, worker: val }));
          }}
        >
          {soEntries}
        </Select>
      </FormControl>
    </>
  );
};
